<mat-accordion class="w100">
  <mat-expansion-panel class="w100" *ngFor="let group of tagGroups">
    <mat-expansion-panel-header>
      <mat-panel-title> {{ group.name }} </mat-panel-title>
      <!-- <mat-panel-description class="row space-between">
        Type your name and age
      </mat-panel-description> -->
    </mat-expansion-panel-header>
    <table class="col w100">
      @for(tag of tags; track tag.id){
      <tr *ngIf="tag.tagGroupId == group.id" class="w100">
        <td class="icon"><rr-icon [name]="tag.icon"></rr-icon></td>
        <td class="name">{{ tag.name }}</td>
        <td class="preview" width="*">
          <rr-badge [icon]="tag.icon" [tone]="group.colorClass">{{
            tag.name
          }}</rr-badge>
        </td>
        <td class="action">
          <div class="row gap-8">
            <rr-icon name="edit" (click)="editTag(tag, group)"></rr-icon>
            <rr-icon name="trash" (click)="deleteTag(tag)"></rr-icon>
          </div>
        </td>
      </tr>
      <div class="tag"></div>
      }
    </table>
    <mat-action-row>
      <rr-btn type="Secondary" iconStart="add" (click)="addTag(group)"
        >Add Tag</rr-btn
      >
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
